import React from 'react';
import axios from 'axios';
import {DeleteRounded, PersonOff, PersonRemoveRounded} from "@mui/icons-material";
import Button from "../../common/Button";
import Tooltip from "../../common/Tooltip";
import PopConfirm from "../../common/PopConfirm";

const RemoveUserFromClassButton = ({
                                       userId,
                                       classId,
                                       userName,
                                       className,
                                       onSuccess,
                                       onError,
                                       confirmTitle = "Are you sure you want to remove this user from the class?",
                                       tooltipText = "Remove from class"
                                   }) => {
    const handleRemoveUserFromClass = async () => {
        try {
            await axios.post(`/web/ui/sc/removeFromClass?classId=${classId}`, [userId]);

            if (displayToastMessage && userName && className) {
                displayToastMessage(`${userName} removed from ${className}`, null, 'success');
            }

            // Call the success callback
            if (onSuccess) {
                onSuccess(userId);
            }
        } catch (error) {
            console.error('Failed to remove user from class:', error);

            if (displayToastMessage) {
                displayToastMessage('Failed to remove user from class', null, 'error');
            }

            // Call the error callback if provided
            if (onError) {
                onError(error);
            }
        }
    };

    return (
        <PopConfirm
            title={<span>{confirmTitle}</span>}
            placement="left"
            okText="Remove User"
            onConfirm={handleRemoveUserFromClass}
        >
            <>
                <Tooltip title={tooltipText}>
                    <Button
                        type="text"
                        aria-label={tooltipText}
                    >
                        <PersonOff style={{ color: 'red' }} />
                    </Button>
                </Tooltip>
            </>
        </PopConfirm>
    );
};

export default RemoveUserFromClassButton;